export default __webpack_public_path__ + "static/media/burntodeath6.c43cc0ba.png";